import { ConditionGroup, FieldTemplate } from './FieldTemplate';

export enum LayoutItemType {
  Input = 'input',
  Static = 'static',
  Container = 'container',
}

export enum LayoutItemSubType {
  HorizontalSeparator = 'horizontal-separator',
  Header = 'header',
  Layout = 'layout',
  SelectableTable = 'selectable-table',
}

export type LayoutItemStyle = {
  backgroundColor?: string;
  paddingTop?: string;
  paddingBottom?: string;
  paddingLeft?: string;
  paddingRight?: string;
  marginTop?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
  justifyContent?: string;
  isRepeatable?: boolean;
};

export type LayoutItem = {
  id?: string;
  _id?: string;
  type: LayoutItemType;
  fieldTemplateId?: string;
  layoutOptions?: {
    style?: LayoutItemStyle;
    layout: string;
    isVisible?: ConditionGroup;
    isRepeatable?: boolean;
    repeatIndex?: number;
    replicaOf?: string;
  };
  children?: LayoutItem[];
  label?: string;
  subType?: LayoutItemSubType;
} & (
  | {
      type: LayoutItemType.Input;
      fieldTemplateId: string;
    }
  | {
      type: LayoutItemType.Container;
      children: LayoutItem[];
    }
  | {
      type: LayoutItemType.Static;
    }
);

export enum FormTemplateStatus {
  Published = 'published',
  Draft = 'draft',
}

export type FormTemplate = {
  id: string;
  version: number;
  layout: {
    items: LayoutItem[];
    options: {
      layout: string;
    };
  };
  fieldTemplates: FieldTemplate[];
  updatedAt?: string;
  status: FormTemplateStatus;
  mappings?: {
    externalCommunication?: {
      hl7Identifier?: string;
    };
  };
};
